import { replenishBalanceRequest, writeOffBalanceRequest } from 'api/Credit/api';
import getErrorFromPromiseReason from 'app/helpers/getErrorFromPromiseReason';
import { updateBalance } from 'store/credits/creditsSlice';
import { useAppDispatch } from 'store/hooks';

import { message, notification } from 'antd';
import { useState } from 'react';

const useChangeBalance = (replenish: boolean, onCancel: () => void) => {
  const dispatch = useAppDispatch();
  const [ isLoading, setIsLoading ] = useState<boolean>(false);

  const callbackRequest = replenish ? replenishBalanceRequest : writeOffBalanceRequest;

  const changeBalance = (orgId: string, amount: number) => {
    setIsLoading(true);

    callbackRequest(orgId, amount)
      .then(({ data }) => {
        message.success(`${replenish ? 'Replenish' : 'Write off'} successful`);
        dispatch(updateBalance(data));
        onCancel();
      })
      .catch((reason) => {
        notification.error({ duration: 0, type: 'error', message: getErrorFromPromiseReason(reason) });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return { isLoading, changeBalance };
};

export default useChangeBalance;
